import {BASE_URL} from "@/utils/config";

export const getAllEventsData = async (axiosInstance) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/admin/event/get-all`);
		return response.data;
	} catch (error) {
		console.log("(admin/eventApi.js) Error while fetching all events: ", error);
	}
}

export const getEventTicketDetails = async (axiosInstance, eventId) => {
	try {
		const response = await axiosInstance.post(`${BASE_URL}/admin/event/get-ticket-details`, {
			eventId: eventId,
		});
		return response.data;
	} catch (error) {
		console.log("(admin/userApi.js) Error while fetching registered users: ", error);
	}
}
